import Vue from 'vue'
import { options as optionsAPI } from '@/api'

const options = {
  state: {
      options: {}
  },
  mutations: {
    'SET_OPTION'(state, {key, value}) {
        Vue.set(state.options, key, value)
    }
  },
  actions: {
    loadOptions({ commit }) {
        return optionsAPI.get().then(response => {
            for (let key in response.data) {
                commit('SET_OPTION', { key, value: response.data[key] })
            }
        })
    }
  }
}

export default options



// WEBPACK FOOTER //
// ./src/store/options/index.js